const styles = {
  sendIconButton: {
    margin: '0 10px',
    padding: 0,
    height: '56px',
  },
  icon: {
    marginLeft: '15px',
  },
};

export default styles;
